(ns manatee.app-db
  "Access to manatee web application configuration."
  (:require #?(:clj [clojure.spec.alpha :as s]
               :cljs [cljs.spec.alpha :as s])
            [manatee.routing :refer [external-routes]]
            [manatee.routing.app-db :refer [set-routes]]))

(s/def ::api-version string?)
(s/def ::config (s/keys :req-un [::api-version]))
(s/def ::db (s/keys :req-un [::config]))

(def config-path [:config])
(def cookies-domain-path (conj config-path :cookies :domain))
(def account-id-path (conj config-path :client :account-id))
(def xhr-retry-limit-path (conj config-path :xhr-retry-limit))
(def ping-interval-seconds-path (conj config-path :ping-interval-seconds))
(def client-version-path
  (conj config-path :version))
(def server-version-path
  (conj config-path :server-version))

(defn get-config
  [db]
  (get-in db config-path))

(defn cookies-domain
  [db]
  (get-in db cookies-domain-path))

(defn account-id
  [db]
  (get-in db account-id-path))

(defn initial-db
  [config]
  (-> {:config config}
      (set-routes (external-routes config))))

(defn xhr-retry-limit
  [db]
  (get-in db xhr-retry-limit-path))

(defn ping-interval-seconds
  [db]
  (get-in db ping-interval-seconds-path))

(defn client-version
  [db]
  (get-in db client-version-path))

(defn server-version
  [db]
  (get-in db server-version-path))

(defn set-server-version
  [db server-version]
  (assoc-in db server-version-path server-version))
